// Fractal aggregator with configurable BASE interval (1m or 5m).
// One N-minute candle is built from exactly N/base consecutive base candles.
// Volume summed, OHLC merged.

export const TF_MINUTES = {
  "1m": 1, "2m": 2, "3m": 3, "5m": 5, "15m": 15,
  "30m": 30, "1h": 60, "4h": 240, "1D": 1440,
};

export function aggregate(bars, tf, baseMinutes = 1) {
  const m = TF_MINUTES[tf] || 1;
  if (m === baseMinutes) return bars.map(b => ({ ...b }));
  if (m < baseMinutes) return []; // cannot upsample finer than base
  const out = [];
  const bucketSecs = m * 60;
  let bucket = null;
  for (const b of bars) {
    const bucketStart = Math.floor(b.time / bucketSecs) * bucketSecs;
    if (!bucket || bucket.time !== bucketStart) {
      if (bucket) out.push(bucket);
      bucket = { time: bucketStart, open: b.open, high: b.high, low: b.low, close: b.close, volume: b.volume || 0 };
    } else {
      bucket.high = Math.max(bucket.high, b.high);
      bucket.low  = Math.min(bucket.low,  b.low);
      bucket.close = b.close;
      bucket.volume += b.volume || 0;
    }
  }
  if (bucket) out.push(bucket);
  return out;
}

export const TF_LIST = Object.keys(TF_MINUTES);

export function tfsAvailableFor(baseMinutes) {
  return TF_LIST.filter(tf => TF_MINUTES[tf] >= baseMinutes);
}

export function tfStopDistance(bars, tf) {
  if (!bars.length) return 1;
  const m = TF_MINUTES[tf] || 1;
  const recent = bars.slice(-20);
  const ranges = recent.map(b => b.high - b.low);
  const avg = ranges.reduce((s, r) => s + r, 0) / (ranges.length || 1);
  return Math.max(avg * Math.max(2, Math.sqrt(m)), 0.5);
}
